<div class="ruleset-modal">
  <div class="modal-header">
    <div>
      <h2>Add proctoring rules</h2>
      <p>Select one or more of the remaining rules to add to this ruleset.</p>
    </div>
    <button class="close-btn" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body" style="padding-top: 20px; padding-bottom: 20px;">
    <div class="rule-select-wrapper" style="width: 100%;">
      <div class="rule-input" (click)="dropdownOpen = !dropdownOpen" style="width: 100%;">
        <span>
          {{
            selectedRules.length
              ? selectedRules.length + " rules selected"
              : "Choose rules..."
          }}
        </span>
        <span class="arrow"> <i class="bi bi-chevron-down"></i> </span>
      </div>

      <div class="rule-dropdown" *ngIf="dropdownOpen" style="width: 100%;">
        <ng-container *ngIf="remainingRules.length > 0; else noRules">
          <div class="rule-item" *ngFor="let rule of remainingRules">
            <input
              type="checkbox"
              [checked]="isSelected(rule)"
              (change)="toggleRule(rule)"
            />
            <span>
              {{ rule.name }}
            </span>
          </div>
          <button class="done-btn" (click)="dropdownOpen = false">
            Done
          </button>
        </ng-container>
        <ng-template #noRules>
          <div style="padding: 10px; font-size: 13px; text-align: center; color: #6b7280;">
            All rules have been added.
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="cancel-btn cancel" (click)="close()">Cancel</button>
    <button class="add-btn" (click)="addRules()">Add Rules</button>
  </div>
</div>
